import React, { useEffect, useState } from "react";
import StripeSubscription from "../component/payment/StripeSubscription";

const PaymentPage = () => {
  return (
    <div className="d-flex justify-content-center">
      <div className="payment-page mt-75">
        <StripeSubscription></StripeSubscription>
      </div>
    </div>
  );
};

export default PaymentPage;
